import React, { useState } from "react";
import InfoButton from "../info-button/InfoButton";
import "./percent-input-label-container.styles.scss";

const PercentInputLabelContainer = (props) => {
    const [isInputOnFocus, setIsInputOnFocus] = useState(false);

    return (
        <div className="compound-interest-calculator__clipped-label-input-container">
            {props.infoText && 
                <InfoButton infoText={props.infoText}/>
            }
            <div
                className={
                    props.isExpanded
                        ? `compound-interest-calculator__clipped-label-input-wrapper--expanded${
                              props.className ? " " + props.className : ""
                          }`
                        : `compound-interest-calculator__clipped-label-input-wrapper${
                              props.className ? " " + props.className : ""
                          }`
                }
            >
                <label className="compound-interest-calculator__clipped-label" htmlFor={props.name}>
                    {props.label}
                </label>
                {/* </span> */}
                <span
                    className={
                        isInputOnFocus
                            ? "compound-interest-calculator__input-add-reduce-buttons-wrapper compound-interest-calculator__input-add-reduce-buttons-wrapper--input-on-focus"
                            : "compound-interest-calculator__input-add-reduce-buttons-wrapper"
                    }
                >
                    <div className="compound-interest-calculator__input-add-reduce-buttons-container">
                        <input
                            value={props.value}
                            name={props.name}
                            onFocus={(e) => {
                                e.target.select();
                                setIsInputOnFocus(true);
                            }}
                            onBlur={(e) => {
                                setIsInputOnFocus(false);
                            }}
                            onChange={props.onChange}
                            onKeyDown={props.onKeyDown}
                            className="percent-input"
                        />
                        <div className="compound-interest-calculator__buttons-container">
                            <button
                                type="button"
                                className="compound-interest-calculator__add-btn-container"
                                onClick={props.addButtonOnClick}
                            >
                                <span className="compound-interest-calculator__add-btn">+</span>
                            </button>
                            <button
                                type="button"
                                className="compound-interest-calculator__reduce-btn-container"
                                onClick={props.reduceButtonOnClick}
                            >
                                <span className="compound-interest-calculator__reduce-btn">-</span>
                            </button>
                        </div>
                    </div>
                </span>
            </div>
        </div>
    );
};

export default PercentInputLabelContainer;
